import { Link } from "react-router-dom";
import "../styles/Footer.css";
import facebook from "../icons/facebook-square_blue.svg";
import instagram from "../icons/instagram-square.svg";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer__container">
        {/* Socials */}
        <section className="footer__socials--container">
          <span className="footer__socials--item">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/bribiepicnics/"
              className="footer__socials--link-icon"
            >
              <img className="small_icon" src={facebook} alt="facebook" />
            </a>
          </span>
          <span className="footer__socials--item">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/bribieislandpicnics/?hl=en"
              className="footer__socials--link-icon"
            >
              <img className="small_icon" src={instagram} alt="instagram" />
            </a>
          </span>
          <span className="footer_info--item-phone">Ph: 0493 294 665</span>
        </section>

        {/* Copyright */}
        <section className="footer__copyright--container">
          <span className="footer__copyright--item">
            &copy; {new Date().getFullYear()} Bribie Island Picnics
          </span>
          {/* <p>Website By WebTech</p> */}
        </section>

        {/* FAQ & Terms */}
        <section className="footer__info--items">
          <div className="footer__info--items-links">
            <span>
              <Link className="footer__info--link" to="/terms">
                Terms&Conditions |
              </Link>
            </span>
            <span>
              <Link className="footer__info--link" to="/faq">
                | FAQ
              </Link>
            </span>
          </div>
        </section>
      </div>
    </div>
  );
}
